import { EmptyArray } from "../domain/empty/model";
import { ParametrizationRepositoryImplementation } from '../infrastructure/parametrization-repository-implementation';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new ParametrizationRepositoryImplementation();
const CACHE_PREFIX = 'parametrization';

async function setParametrization(uid: string, cid: string | null, payload: any) {
    const response = await repo.setParametrization(uid, cid, payload).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function getParametrization(uid: string, cid: string | null) {
    const response = await repo.getParametrization(uid, cid).toPromise();
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    return data;
}

async function getParametrizationTypes(uid: string, cid: string | null) {
    const cacheKey = `${CACHE_PREFIX}-types-${uid}-${cid}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const response = await repo.getParametrizationTypes(uid, cid).toPromise();
    if (!response || !response.data) return EmptyArray;
    const data = response.data;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function setParametrizationBatch(uid: string, cid: string | null, items: any[]) {
    const response = await repo.setParametrizationBatch(uid, cid, items).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

export { setParametrization, setParametrizationBatch, getParametrization, getParametrizationTypes };

